import { Table, Popover } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { evaluationQuestions } from "views/Requisition/AddUpdateEmployeeEvaluation/Includes/evaluationQuestions";

const EvaluationTableSupervisor = ({
  participantEmployeeEvaluationForm,
  Supervisor,
}) => {
  const [selectedRecord, setSelectedRecord] = useState(null);

  useEffect(() => {
    if (Supervisor !== undefined) {
      setSelectedRecord(Supervisor);
    }
  }, [Supervisor]);

  //console.log("EvaluationTable Supervisor ", selectedRecord);
  // console.log(
  //   "EvaluationTable Supervisor Final ",
  //   participantEmployeeEvaluationForm
  // );

  const columns = [
    {
      title: "Evaluation Criteria",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <>
          {record.title}{" "}
          <Popover content={record.description}>
            <ExclamationCircleOutlined />
          </Popover>
        </>
      ),
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
    },
  ];

  // Flatten each evaluation field into row data
  const dataSource = evaluationQuestions.map((criteria, index) => {
    const rating =
      participantEmployeeEvaluationForm?.[criteria.key]?.number || "N/A";
    const comment =
      participantEmployeeEvaluationForm?.[criteria.key]?.comments || "";
    return {
      key: index,
      title: criteria.title,
      description: criteria.description,
      rating,
      comment,
    };
  });

  return (
    <>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered
      />

      <br />
      <br />

      <div>
        <strong>Major Strength2:</strong> <br />
        {participantEmployeeEvaluationForm?.majorStrength || "N/A"}
      </div>
      <br />
      <hr />
      <br />
      <div>
        <strong>Areas of Improvement:</strong> <br />
        {participantEmployeeEvaluationForm?.areasOfImprovement || "N/A"}
      </div>
       <hr />
      <br />
      <div>
        <strong>Other Remarks/Recommendation:</strong> <br />
        {participantEmployeeEvaluationForm?.otherRemarksIncrement || "N/A"}
      </div>
    </>
  );
};

export default EvaluationTableSupervisor;
